var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('a',{attrs:{"href":_vm.d.link,"target":"_blank"}},[_c('img',{attrs:{"src":_vm.$cdn + _vm.d.img}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }